/**
 * Fallback used when `system/public_config.contact_sales_url` is unset, so the
 * "Contact sales" CTA always has a destination (no dead-end modal). Shared by
 * PricingPlans and ContactSalesDialog.
 */
export const DEFAULT_CONTACT_SALES_URL = 'https://myauditcorner.com/contact'
